import segmentClient from 'flow/api-clients/segment-client';
import { getOwnExtensionKey } from 'flow/selectors/selectors';
import {
    selectAnalyticsConsent,
    selectConsentCategories,
} from 'flow/selectors/app-selectors';

const initiateSegment = () => (_dispatch, getState) => {
    const state = getState();

    if (!isAnalyticsAllowed(state)) {
        return;
    }

    const { customer } = state;
    const customerEntityKey = getOwnExtensionKey(state);
    const loggedInCustomer = customer.get(customerEntityKey);
    const customerKey = loggedInCustomer && loggedInCustomer.get('key');

    segmentClient.init(customerKey);
};

const isAnalyticsAllowed = (state) => {
    const analyticsConsent = selectAnalyticsConsent(state);
    if (analyticsConsent === 'accepted') return true;
    if (analyticsConsent === 'partial') {
        const categories = selectConsentCategories(state);
        return categories ? categories.get('analytics') === true : false;
    }
    return false;
};

export const segmentTrack = (event, eventData) => (dispatch, getState) => {
    if (!isAnalyticsAllowed(getState())) return;

    if (!segmentClient.initialized) {
        dispatch(initiateSegment());
    }
    segmentClient.track(event, eventData);
};
